import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Building2, Package as PackageIcon, CreditCard, LogOut, ShieldCheck } from "lucide-react";
import { useEffect } from "react";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/businesses", icon: Building2, label: "Businesses" },
  { to: "/admin/plans", icon: PackageIcon, label: "Plans" },
  { to: "/admin/payments", icon: CreditCard, label: "Payments" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (user && !["super_admin", "admin"].includes(user.role)) {
      nav("/app");
    }
  }, [user, nav]);

  const onLogout = async () => { await logout(); nav("/login"); };

  return (
    <div className="min-h-screen bg-muted/30 flex">
      <aside className="w-60 border-r bg-card flex flex-col" data-testid="admin-sidebar">
        <div className="h-16 flex items-center gap-2 px-5 border-b">
          <div className="w-9 h-9 rounded-lg bg-foreground text-background grid place-items-center font-heading font-bold text-sm">
            <ShieldCheck size={16} />
          </div>
          <div>
            <div className="font-heading font-bold text-base leading-tight">TheBillPro Admin</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Super Panel</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-0.5">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all ${
                  isActive ? "bg-foreground text-background font-semibold" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                }`
              }
            >
              <n.icon size={16} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t space-y-2">
          <div className="text-xs px-2 text-muted-foreground truncate">{user?.email}</div>
          <Button variant="outline" size="sm" onClick={onLogout} className="w-full" data-testid="admin-logout">
            <LogOut size={14} className="mr-1" /> Sign out
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="max-w-[1400px] mx-auto p-6 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
